




















import { Component, Prop, Vue } from "vue-property-decorator";

import { Challenge } from "@/models/definitions";

@Component
export default class AdminChallengeCard extends Vue {
  @Prop({ required: true }) readonly challenge!: Challenge;

  get date(): string {
    if (this.challenge.date) {
      return (
        this.challenge.date.getDate() +
        "." +
        (this.challenge.date.getMonth() + 1) +
        "." +
        this.challenge.date.getFullYear()
      );
    }
    return "";
  }
}
